module.exports = __webpack_public_path__ + "static/media/die_lower_res.db05cdb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Landingpage/die_lower_res.jpg
// module id = 421
// module chunks = 64